var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7084 0H3.37508C1.53441 0 0.041748 1.49267 0.041748 3.33333V12.6667C0.041748 14.5073 1.53441 16 3.37508 16H12.7084C14.5497 16 16.0417 14.5073 16.0417 12.6667V3.33333C16.0417 1.49267 14.5497 0 12.7084 0ZM5.37508 12.6667H3.37508V5.33333H5.37508V12.6667ZM4.37508 4.488C3.73108 4.488 3.20841 3.96133 3.20841 3.312C3.20841 2.66267 3.73108 2.136 4.37508 2.136C5.01908 2.136 5.54175 2.66267 5.54175 3.312C5.54175 3.96133 5.01975 4.488 4.37508 4.488ZM13.3751 12.6667H11.3751V8.93067C11.3751 6.68533 8.70842 6.85533 8.70842 8.93067V12.6667H6.70842V5.33333H8.70842V6.51C9.63908 4.786 13.3751 4.65867 13.3751 8.16067V12.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.18fa00dc8e7a07f5d339e2a7f70a41ab.svg";
export { ForwardRef as ReactComponent };